module.exports = __webpack_public_path__ + "img/9.a2b60f44.jpg";